module.exports = __webpack_public_path__ + "static/media/file-check.6ad7fca5.svg";